export type HistoryResponse = {
  creationDate: Date;
  status: string;
  subStatus: string;
  content: string;
  type: string;
};

export type HistoryElement = {
  creationDate: string;
  authorName?: string;
  content?: HistoryElementContent[];
  contentType: HistoryElementContentType | null;
};

export type HistoryElementContent = {
  strContent?: string;
  sectionTitle?: string;
  modifications?: HistoryElementContentModifications[];
  statusChange?: { oldStatus: StatusType; newStatus: StatusType; displayChip?: boolean };
};

export type HistoryElementContentModifications = {
  field: string;
  oldValue: string;
  newValue: string;
};

export enum HistoryElementContentType {
  STRING = 'STRING',
  JSON = 'JSON',
  STATUS_CHANGE = 'STATUS_CHANGE'
}

export enum StatusType {
  DECLINED = 'DECLINED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  FINAL = 'FINAL',
  CONDITIONAL_APPROVE = 'CONDITIONAL_APPROVE',
  FUNDED = 'FUNDED',
  CLOSED = 'CLOSED',
  ERROR = 'ERROR',
  TO_CANCEL = 'TO_CANCEL',
  NOT_FUNDABLE = 'NOT_FUNDABLE',
  NONE = 'NONE'
}
